import { settingsStateTypes } from "./settings.types";

export const setSelectedTimeZone = (timeZone) => ({
  type: settingsStateTypes.SET_CURRENT_TIMEZONE,
  payload: timeZone,
});
